
const digest = 'b8a3a015f847386c2056def78bde1bc07bb019f54b1ed6f8723be8e1aaa99336';
const classes = {"wrapper":"_wrapper_15m3g_1"};
const css = `._wrapper_15m3g_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  border: 1px solid #eaedf3;
  padding: 12px 24px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  